import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
//atoms
import { useRecoilValue } from 'recoil';
import dateJoinedAtom from "recoil/account/dateJoined";
//utils
import moment from 'moment';
import { generateEarningsYearOptions } from "utils/optionsProvider";
import { currencyFormatter, numberFormatter } from 'utils/formatter';
//hooks
import useReferral from 'hooks/useReferral';
import useReferralEarnings from 'hooks/useReferralEarnings';
//fonts
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const InsightsReferral = (props) => {
    const datePickRef = useRef(null);
    const curYear = moment().year();
    const yearOptions = generateEarningsYearOptions(useRecoilValue(dateJoinedAtom));

    const [selectedYear, setSelectedYear] = useState(curYear);
    const [dateSelDropdownOn, setDateSelDropdownOn] = useState(false);

    const [referralSelectionValue, setReferralSelectionValue] = useState(0);

    const [hoveredId, setHoveredId] = useState(null);
    
     const [isClicked, setIsClicked] = useState(false);
        
    const handleHoveredClicked = (id)=>{
        
        setHoveredId(prev=>{
            if(prev != id) {
                return id;
            }
            return null;
        });
        setIsClicked(prev=>!prev);
    }
    
    const { data: referralList} = useReferral();
    const { data: earnings } = useReferralEarnings(referralSelectionValue, selectedYear);

    const updateSelYear = (year, e) => {
        e.preventDefault();
        setSelectedYear(year);
        setDateSelDropdownOn(false);
    }
    
    const referralSelectionRef = useRef(null);
    const [referralSelectionOn, setReferralSelectionOn] = useState(false);

    const handleReferralSelection = (value) => {
        setReferralSelectionValue(value);
        setReferralSelectionOn(false);
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (referralSelectionRef.current && !referralSelectionRef.current.contains(event.target))
                setReferralSelectionOn(false);

        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => { document.removeEventListener("mousedown", handleClickOutside); };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (datePickRef.current && !datePickRef.current.contains(event.target))
                setDateSelDropdownOn(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => { document.removeEventListener("mousedown", handleClickOutside); };
    }, []);

    useEffect(() => {
        function handleClickOutside(e) {
            if (hoveredId) {
                setHoveredId(null);
                setIsClicked(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [hoveredId]);

    return (


        <div className={classNames('card', 'campaign')}>
            <div className='card-header'>
                <div ref={referralSelectionRef} className={classNames('campaign-selection-list', 'selection-list', { on: referralSelectionOn })}>
                    <select
                        className='table-select'
                        value={referralSelectionValue}
                        onChange={(e)=>{e.preventDefault(); handleReferralSelection(e.target.value)}}
                        >
                        <option value="-1">All referrals</option>
                        {
                            referralList?.length > 0
                            && [...referralList]
                                .sort((a, b) => a.Name.toLowerCase() > b.Name.toLowerCase() ? 1 : -1)
                                .map((item) => (
                                     <option 
                                        key={`refItm_${item.AffiliateID}`}
                                        value={item.AffiliateID}
                                        >{item.Name}</option>
                                ))
                        }
                    </select>
                    
                    {/* <p className='selection-value' onClick={() => { setReferralSelectionOn(!referralSelectionOn) }}>
                        <span className='campaign-title'>
                            {
                                referralSelectionValue < 1
                                    ? 'All referrals'
                                    : referralList?.find(itm => itm.AffiliateID === referralSelectionValue)?.Name ?? 'All referrals'
                            }
                        </span>
                        {referralSelectionOn
                            ? <FontAwesomeIcon className='arrow-up-ico' icon={faChevronUp} />
                            : <FontAwesomeIcon className='arrow-down-ico' icon={faChevronDown} />}
                    </p>
                    <ul className='selection-option-list'>
                        <li>
                            <a
                                className={classNames('selection-item', { 'on': referralSelectionValue < 1 })}
                                onClick={() => handleReferralSelection(0)}
                            >All referrals</a>
                        </li>
                        {
                            referralList?.length > 0
                            && [...referralList]
                                .sort((a, b) => a.Name.toLowerCase() > b.Name.toLowerCase() ? 1 : -1)
                                .map((item) => (
                                    <li key={`ref_${item.AffiliateID}`}>
                                        <a
                                            className={classNames('selection-item', { 'on': item.AffiliateID === referralSelectionValue })}
                                            onClick={() => handleReferralSelection(item.AffiliateID)}
                                        >{item.Name}</a>
                                    </li>
                                ))
                        }
                    </ul> */}
                </div>

                <div className="date-select">
                    <p  className="selected-date" onClick={(e) => { setDateSelDropdownOn(!dateSelDropdownOn); e.stopPropagation() }}>{selectedYear} <FontAwesomeIcon icon={faChevronDown} /></p>
                    <div ref={datePickRef} className={classNames("date-pick", { "on": dateSelDropdownOn })}>
                        <ul>
                            {
                                yearOptions.map((year, i) => <li key={`rdt_${i}`}><a href="/" title="Today" onClick={(e) => { updateSelYear(year, e) }}>{year}</a></li>)
                            }
                        </ul>
                    </div>
                </div>
            </div>
            <div className='card-content'>
                <table className="compaign-table total-earning">
                    <thead className={classNames("thead")}>
                        <tr>
                            <th>Date</th>
                            <th>Joins</th>
                            <th>Sales</th>
                            <th>Earnings</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            earnings &&
                            <>
                                {
                                    earnings?.Data.length > 0
                                        ? [...earnings.Data]
                                            .sort((a, b) => a.Stats.Date > b.Stats.Date ? 1 : -1)
                                            .map((campaign, i) => {
                                                const rowid = `campaignref_${referralSelectionValue}_${selectedYear}_browser_${i}`;
                                                return (
                                                <tr key={rowid}>
                                                    <td><span className='campaign-date'>{moment(campaign.Stats.Date).format("MMM YYYY")}</span></td>
                                                    <td>{campaign.Stats.Joins > 0 ? numberFormatter.format(campaign.Stats.Joins) : '-'}</td>
                                                    <td>
                                                        {campaign.Stats.Upgrades > 0 ? numberFormatter.format(campaign.Stats.Upgrades) : '-'} 
                                                        {/* {campaign.Stats.Upgrades > 0 && campaign.Stats.Joins > 0 ? `(${Math.round(campaign.Stats.Upgrades * 100 / campaign.Stats.Joins)}%)` : ``} */}
                                                    </td>
                                                    <td className='tooltip'>
                                                        <span translate="no" className="notranslate" 
                                                                onClick={()=>{  if(campaign.Stats.Revenue > 0){ handleHoveredClicked(rowid)}}}
                                                                onMouseEnter={() => { campaign.Stats.Revenue > 0 && setHoveredId(rowid)}}
                                                                onMouseLeave={() => {campaign.Stats.Revenue > 0 && !isClicked && setHoveredId(null)}} >
                                                            {campaign.Stats.Revenue > 0 ?currencyFormatter.format(campaign.Stats.Revenue) : '-'}
                                                        </span>
                                                        {   
                                                            hoveredId == rowid 
                                                            && 
                                                            <em className='tooltip-bubble'>
                                                                <span className='title'>Earnings breakdown</span>
                                                                <span>Revenue Share: <span translate="no"  className='notranslate'>{currencyFormatter.format(campaign.Stats.Revenue - (campaign.Stats.RevenueQL ?? 0))}</span></span>
                                                                <span className='ql'><span>Qualified Leads:</span><span translate="no"  className={classNames("notranslate", {"dash":!campaign.Stats.RevenueQL || campaign.Stats.RevenueQL < 1})}>{ (campaign.Stats.RevenueQL && campaign.Stats.RevenueQL) > 0 ? currencyFormatter.format(campaign.Stats.RevenueQL) : '-'}</span></span>
                                                            </em>
                                                        }
                                                    </td>
                                                </tr>
                                            )})
                                        : <tr><td className='empty' colSpan={4}>No results found</td></tr>
                                }
                            </>
                        }
                    </tbody>
                </table>
            </div>
        </div>


    );
}

export default InsightsReferral;
